const $dadataUrl = $('meta[name="dadata-url"]');
const $dadataApiKey = $('meta[name="dadata-api-key"]');

window.initDaData = function () {
    if (!$dadataUrl.length || !$dadataApiKey.length) {
        return;
    }

    const dadataUrl = $dadataUrl.attr('content');
    const dadataApiKey = $dadataApiKey.attr('content');

    if (!dadataUrl.length || !dadataApiKey.length) {
        return;
    }

    const $items = $('.dadata-item:not(.suggestions-input)');

    if (!$items.length) {
        return;
    }

    BX.loadCSS('https://cdn.jsdelivr.net/npm/suggestions-jquery@latest/dist/css/suggestions.min.css');
    BX.loadScript('https://cdn.jsdelivr.net/npm/suggestions-jquery@latest/dist/js/jquery.suggestions.min.js', function () {
        $items.each(function (index, item) {
            $(item).suggestions({
                serviceUrl: dadataUrl,
                partner: 'BITRIX.GORILLAS',
                token: dadataApiKey,
                type: $(item).data('dadata-type'),
            });
        });
    });
}

window.initDaData();
